/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListAgentVersionsQueryParamOrder = {
  Asc: "asc",
  Desc: "desc",
} as const;
export type ListAgentVersionsQueryParamOrder = ClosedEnum<
  typeof ListAgentVersionsQueryParamOrder
>;

export type ListAgentVersionsRequest = {
  agentId: string;
  limit?: number | undefined;
  order?: ListAgentVersionsQueryParamOrder | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ListAgentVersionsQueryParamOrder$inboundSchema: z.ZodNativeEnum<
  typeof ListAgentVersionsQueryParamOrder
> = z.nativeEnum(ListAgentVersionsQueryParamOrder);
/** @internal */
export const ListAgentVersionsQueryParamOrder$outboundSchema: z.ZodNativeEnum<
  typeof ListAgentVersionsQueryParamOrder
> = ListAgentVersionsQueryParamOrder$inboundSchema;

/** @internal */
export const ListAgentVersionsRequest$inboundSchema: z.ZodType<
  ListAgentVersionsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  agent_id: z.string(),
  limit: z.number().int().default(20),
  order: ListAgentVersionsQueryParamOrder$inboundSchema.default("desc"),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListAgentVersionsRequest$Outbound = {
  agent_id: string;
  limit: number;
  order: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListAgentVersionsRequest$outboundSchema: z.ZodType<
  ListAgentVersionsRequest$Outbound,
  z.ZodTypeDef,
  ListAgentVersionsRequest
> = z.object({
  agentId: z.string(),
  limit: z.number().int().default(20),
  order: ListAgentVersionsQueryParamOrder$outboundSchema.default("desc"),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listAgentVersionsRequestToJSON(
  listAgentVersionsRequest: ListAgentVersionsRequest,
): string {
  return JSON.stringify(
    ListAgentVersionsRequest$outboundSchema.parse(listAgentVersionsRequest),
  );
}
export function listAgentVersionsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListAgentVersionsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAgentVersionsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAgentVersionsRequest' from JSON`,
  );
}
